export default __webpack_public_path__ + "static/media/dot.5c5e59d8.svg";